import { render, staticRenderFns } from "./MergeFieldDropdown.vue?vue&type=template&id=3e68d2a9&scoped=true"
import script from "./MergeFieldDropdown.vue?vue&type=script&lang=js"
export * from "./MergeFieldDropdown.vue?vue&type=script&lang=js"
import style0 from "./MergeFieldDropdown.vue?vue&type=style&index=0&id=3e68d2a9&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68d2a9",
  null
  
)

export default component.exports